export const MEDIA_MIN_WIDTH_SM = 640;
export const MEDIA_MIN_WIDTH_MD = 768;
export const MEDIA_MIN_WIDTH_LG = 1024;
export const MEDIA_MIN_WIDTH_XL = 1281;
export const MEDIA_MAX_WIDTH_SM = MEDIA_MIN_WIDTH_MD - 1;
export const MEDIA_MAX_WIDTH_MD = MEDIA_MIN_WIDTH_LG - 1;
export const MEDIA_MAX_WIDTH_LG = MEDIA_MIN_WIDTH_XL - 1;
export const MEDIA_SM = { maxWidth: MEDIA_MIN_WIDTH_SM };
export const MEDIA_MD = { maxWidth: MEDIA_MAX_WIDTH_MD };
export const MEDIA_LG = {
    maxWidth: MEDIA_MAX_WIDTH_LG,
    minWidth: MEDIA_MIN_WIDTH_LG,
};
export const MEDIA_XL = { minWidth: MEDIA_MIN_WIDTH_XL };
